































import {Component, Prop, Vue} from 'vue-property-decorator';
import {httpService} from '@/services';
import {i18nMixin} from '@/modules/neodash/mixins';
import {CONFIG} from '@/config';
import {AxiosResponse} from 'axios';
import * as pbi from 'powerbi-client';

import ReportPlaceHolder from '../report-placeholder/report.placeholder.vue';
import BigIconPanel from '../big-icon-panel/big-icon-panel.vue';
import HomeButtonComponent from '@/components/home-button/home-button.component.vue';

@Component({
  name: 'ReportPowerBiContainer',
  components: {
    ReportPlaceHolder,
    BigIconPanel,
    HomeButtonComponent,
  }
})
export default class ReportPowerBiContainer extends Vue {
  public readonly translate = i18nMixin.methods.i18n;

  @Prop({required: true})
  public workspaceId: string;

  @Prop({required: true})
  public reportId: string;

  private report;
  private embedType: string = 'report';
  private powerBi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);

  public created() {
    this.getPbiParameters();
  }

  public async print() {
    try {
      await this.report.print();
    } catch (err) {
      console.log(err);
    }
  }

  public fullscreen() {
    if (this.report) {
      this.report.fullscreen();
    }
  }

  public getPbiParameters(): void {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/neodash/pbi/${this.workspaceId}/config/${this.reportId}`)
      .then((embedConfig: AxiosResponse) => {
        const reportConfig = {
          type: this.embedType,
          tokenType: pbi.models.TokenType.Embed,
          accessToken: embedConfig.data.embedToken.token,
          embedUrl: `${CONFIG.URL.PBIURL}reportEmbed?reportId=${this.reportId}&groupId=${this.workspaceId}`,
        };

        this.report = this.powerBi.embed(this.$refs.content as HTMLElement, reportConfig);

        this.report.off('loaded');
        this.report.on('loaded', () => {
          console.log('Report load successful');
        });

        this.report.off('rendered');
        this.report.on('rendered', () => {
          console.log('Report render successful');
        });

        // Clear any other error handler events
        this.report.off('error');

        this.report.on('error', function (event) {
          const errorMsg = event.detail;

          // Use errorMsg variable to log error in any destination of choice
          console.error(errorMsg);
          return;
        });
      })
  }
}
